import { render } from "./LoaderBar.vue?vue&type=template&id=1765514c&scoped=true"
import script from "./LoaderBar.vue?vue&type=script&lang=js"
export * from "./LoaderBar.vue?vue&type=script&lang=js"

import "./LoaderBar.vue?vue&type=style&index=0&id=1765514c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1765514c"]])

export default __exports__